export function tryParseJson<T = any>(jsonString: string): T | undefined {
  try {
    return JSON.parse(jsonString) as T;
  } catch {
    return undefined;
  }
}
